import { useMutation, useQueryClient } from 'react-query';
import { useRouter } from 'next/router';

import * as routes from 'pages/routes';
import * as authService from 'resources/auth/auth.service';

const logout = async () => {
  await authService.signOut();
};

export default function useSignout() {
  const router = useRouter();
  const queryClient = useQueryClient();

  return useMutation(
    () => logout(),
    {
      onSuccess: () => {
        // remove all queries from the cache
        queryClient.removeQueries();
        // redirect to the sign in page
        window.location.href = routes.path.signIn;
      },
    },
  );
}
